import { Growl } from 'angular/custom/services/growl.service';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';
import * as angular from 'angular';

class TradingPrivacySettingsComponentCtrl implements ng.IController {
    private settings: TsoSecondarySettingsDto;
    private authenticatedUser: LoginResult;

    constructor(
        private growl: Growl,
        private errorHandler: ErrorHandler,
        private TransmissionSystemOperator: TransmissionSystemOperatorResource
    ) {}

    $onInit() {}

    public onAllowCompletelyAnonymousTradingChange() {
        this.TransmissionSystemOperator.saveAllowCompletelyAnonymousTrading(
            { id: this.authenticatedUser.referenceId },
            this.settings.allowCompletelyAnonymousTrading,
            () => {
                this.growl.show('Successfully saved.', 'success', {
                    delay: 2000
                });
            },
            this.errorHandler
        );
    }

    public onEnablePricePublication() {
        this.TransmissionSystemOperator.saveEnablePricePublication(
            { id: this.authenticatedUser.referenceId },
            this.settings.enablePublicationOfPriceInformation,
            () => {
                this.growl.show('Successfully saved.', 'success', {
                    delay: 2000
                });
            },
            this.errorHandler
        );
    }

    public onAllowTraderLists() {
        this.TransmissionSystemOperator.saveAllowTraderLists(
            { id: this.authenticatedUser.referenceId },
            this.settings.allowShippersToUseTraderLists,
            () => {
                this.growl.show('Successfully saved.', 'success', {
                    delay: 2000
                });
            },
            this.errorHandler
        );
    }
}

angular.module('app').component('pkpTradingPrivacySettings', {
    controller: TradingPrivacySettingsComponentCtrl,
    template:
        require('app/operator-settings-secondary-market/trading-privacy-settings.component.html'),
    bindings: {
        settings: '=',
        authenticatedUser: '='
    }
});
